/**
 * Cicla tutti i file .api.js e ne genera dei moduli richiamabili
 */

const api = require.context('.', false,  /\.api\.js$/);
const endpoints = {};

api.keys().forEach(filename => {
  const moduleName = filename
    .replace(/(\.\/|\.api\.js)/g, '')
    .replace(/^\w/, c => c.toUpperCase())

  endpoints[moduleName] = api(filename).default || api(filename);
});

window.apiEndpoint = endpoints;

export default endpoints;